import { useField } from 'formik';
import { FunctionComponent, useState } from 'react';
import { Error, Label } from 'src/shared-components/Form';

interface ProjectComponentProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  required?: boolean;
  options: Array<{
    value: any;
    label: string;
  }>;
  helpText?: string;
  type?: string;
}

const MultiOption: FunctionComponent<ProjectComponentProps> = ({
  label,
  required = false,
  helpText,
  options,
  type = 'checkbox',
  ...rest
}: ProjectComponentProps) => {
  const [field, { touched }, helpers] = useField({
    name: rest.name || '',
    type: type,
  });
  const [selectedItems, setSelectedItems] = useState<any>([]);

  return (
    <div className={rest.className}>
      {label && <Label text={label} required={required} name={field.name || ''} />}
      {helpText && <div className="text-xs mt-1 text-gray-400 mb-4">{helpText}</div>}
      <ul className="mt-1">
        {options.map(option => (
          <li key={option.value} className="mb-1">
            <div className="relative flex items-start">
              <div className="flex items-center h-5">
                <input
                  id={option.value}
                  data-testid={type}
                  aria-describedby={`${option.value}-description`}
                  name={rest.name}
                  type={type}
                  checked={selectedItems.includes(option.value)}
                  onChange={() => {
                    let newItems = [];
                    if (selectedItems.includes(option.value)) {
                      newItems = selectedItems.filter((value: any) => value !== option.value);
                    } else {
                      newItems = [...selectedItems, option.value];
                    }

                    setSelectedItems(newItems);
                    if (required && newItems.length === 0) {
                      // This is not updating the state
                      // so I have to do the same thing in line 64
                      helpers.setError('At least one must be selected');
                    }
                    helpers.setValue(newItems);
                    helpers.setTouched(true);
                  }}
                  className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded"
                />
              </div>
              <div className="ml-3 text-sm text-left">
                <label htmlFor={option.value} className="text-gray-700">
                  {option.label}
                </label>
              </div>
            </div>
          </li>
        ))}
      </ul>
      {required && selectedItems.length === 0 && touched && <Error error={'At least one must be selected'} />}
    </div>
  );
};

export default MultiOption;
